/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import coupon2 from '../../assets/images/coupon2.png';
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from 'react-redux';
import { SearchCouponById, UpdateQrCode, SearchQrCode } from "../../services/Coupon";
import { setShop } from "../../features/ShopSlice";
import helper from "../../functions/helper";

export default function ShopCouponConfirm() {

    const { liff } = useLiff();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const store = useSelector((state) => state.shop)
    const [page, setPage] = React.useState("info");
    const [couponDetail, setCouponDetail] = React.useState(null);
    const now = new Date()


    React.useEffect(() => {
        getSearchQrCode()
    }, []);

    async function getSearchQrCode() {
        return await SearchQrCode({ data: { qrCode: store['qrCode'], shopId: store['shopId'] } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    let data = response.data.body
                    if (data.coupon.discountType === 'Fix') {
                        data.coupon.discountText = `฿${helper.numberWithCommas(data.coupon.discount)} | ขั้นต่ำ ฿${helper.numberWithCommas(data.coupon.min)}`
                    } else {
                        data.coupon.discountText = `${helper.numberWithCommas(data.coupon.discount)}% | ขั้นต่ำ ฿${helper.numberWithCommas(data.coupon.min)}`
                    }
                    fnSetData('couponDetail', data)
                    setCouponDetail(data)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function postUpdateQrCode() {
        return await UpdateQrCode({ data: { couponId: couponDetail.coupon.id, memberId: couponDetail.member.id, qrCode: store['qrCode'] , shopId: store['shopId'] } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    navigate('/shop-coupon-success')
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setShop(tmpObj));
    }



    return (
        <>
            <TopLogo />

            {couponDetail &&
                <div
                    style={{
                        background: "#005AAA",
                        paddingTop: "20px"
                    }}
                >
                    <div className="text-white text-center text-[20px] mb-[15px]">
                        {couponDetail.shop.name}
                    </div>

                    <div className="overflow-y-auto px-[20px]" style={{ height: "calc(100vh - 220px)" }}>
                        {/* <InfiniteScroll
                        loadMore={fetchItems}
                        hasMore={isLoading}
                        loader={loader}
                    > */}
                        <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">

                            <div className="text-center">
                                <p className="text-blue text-[24px]">{couponDetail.coupon.name}</p>
                                <p className="text-darkGray text-[20px]">ส่วนลด {couponDetail.coupon.discountText}</p>
                                <p className="text-darkGray text-[20px]">ใช้คูปองได้ถึง {dayjs(couponDetail.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                            </div>

                            <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />


                            {couponDetail.coupon.picture ? (
                                <img
                                    className="mx-auto mt-[10px]"
                                    src={couponDetail.coupon.picture}
                                    alt="logo"
                                    style={{ width: "208px" }}
                                />
                            ) : (
                                <img
                                    className="mx-auto mt-[10px]"
                                    src={coupon2}
                                    alt="logo"
                                    style={{ width: "208px" }}
                                />
                            )
                            }

                            <p className="text-[24px]">รายละเอียด</p>
                            <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />
                            <div className="mt-[5px] flex justify-between items-start">
                                <p className="text-[16px] whitespace-pre-line leading-[24px]">
                                    รหัสคูปอง:
                                </p>
                                <p className="text-[20px]">{couponDetail.qrCode}</p>
                            </div>
                            <div className="flex justify-between items-start">
                                <p className="text-[16px] whitespace-pre-line leading-[24px]">
                                    วันที่/เวลาใช้คูปอง:
                                </p>
                                <p className="text-[20px]">{dayjs(now).format('DD/MM/YYYY HH:mm:ss')}น.</p>
                            </div>

                            <div className="flex justify-between items-start">
                                <p className="text-[16px] leading-[24px]">
                                    ผู้ใช้ :
                                </p>
                                <p className="text-[20px]">{couponDetail.member.name}</p>
                            </div>

                            {/* <div className="flex justify-between items-start">
                                <p className="text-[16px] whitespace-pre-line leading-[24px]">
                                    ส่วนลด :
                                </p>
                                <p className="text-[20px]">{helper.numberWithCommas(couponDetail.coupon.discount)}{couponDetail.coupon  .discountType === "Percent" ? "%" : "฿"}</p>
                            </div> */}




                        </div>

                    </div>
                    <div className="bg-white h-[100px] pt-[25px]">
                        <Stack
                            spacing={2}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <SecondaryButton variant="outlined" className="w-[45%]" onClick={() => navigate(-1)}>
                                ยกเลิก
                            </SecondaryButton>
                            <PrimaryButton
                                variant="outlined"
                                className="w-[45%]"
                                onClick={() => postUpdateQrCode()}
                            >
                                ยืนยันใช้คูปอง
                            </PrimaryButton>
                        </Stack>


                    </div>
                </div>}


        </>
    );
}
